module.exports = __webpack_public_path__ + "static/img/H1.3a0d778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/H1.png
// module id = ffjS
// module chunks = 0